<script lang="ts">
  import Dialog from '@/components/dialog';
  import {Configuration} from '@/types/settings';
  import dayjs from 'dayjs';
  import {createEventDispatcher} from 'svelte';

  const dispatch = createEventDispatcher<{
    addCookie: Configuration;
    close: void;
  }>();

  $: formData = {
    name: dayjs().format('YYYY.MM.DD.HH.mm.ss'),
    value: ''
  };

  $: fileName = `cookies-${formData.name}.txt`;

  const onSubmit = () => {
    dispatch('addCookie', {
      type: 'ytdlp',
      name: fileName,
      options: {
        cookies: formData.value
      }
    });
    dispatch('close');
  };
</script>

<Dialog isDialogOpen={true} on:close={() => dispatch('close')}>
  <div class="flex h-full w-full items-end justify-center text-sermon-base lg:items-center">
    <form
      on:submit|preventDefault={onSubmit}
      class="h-auto max-h-[80vh] w-full min-w-[280px] space-y-8 overflow-y-auto rounded-t-2xl border border-zinc-400 bg-white p-12 shadow-lg dark:border-zinc-600 dark:bg-zinc-700 lg:max-w-[680px] lg:rounded-2xl"
    >
      <div class="flex items-center justify-between">
        <h2 class="text-2xl font-bold">Add Cookie</h2>
        <button on:click|preventDefault={() => dispatch('close')} class="ml-auto rounded-full px-2 hover:bg-zinc-100">
          <i class="fa-solid fa-xmark p-2 text-lg" aria-label="Close Mooda"></i>
        </button>
      </div>
      <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-1">
          <label for="name" class="text-sm">File Name</label>
          <input
            type="text"
            bind:value={formData.name}
            required
            class="w-full rounded-md border border-gray-300 px-4 py-2 text-sm ring-0 focus:border-sermon-pink focus:ring-sermon-pink"
          />
          <span class="text-xs text-gray-500">{fileName}</span>
        </div>
        <div class="flex flex-col gap-1">
          <label for="value" class="text-sm">Cookie</label>
          <textarea
            bind:value={formData.value}
            required
            class="h-full max-h-[256px] min-h-[256px] w-full overflow-y-auto rounded-md border border-gray-300 px-4 py-2 text-sm ring-0 focus:border-sermon-pink focus:ring-sermon-pink"
          />
        </div>
        <div class="flex justify-end">
          <button type="submit" class="btn btn-primary"> Add Cookie </button>
        </div>
      </div>
    </form>
  </div>
</Dialog>
